import { LoginPasswordType } from "../register/user-register";

export class MobileTopupVerifyPorivderQueryString {
    public Amount: number;
    public Currency: string;
    public ProductId: number;
    public mobile: string;
}

export class MobileTopupQueryString {
    public CustomerId: string;
    public mobile: string;
    public BillerlocationId: string;
    public ProductId: number;
    public TransactionAmount: number;
    public TransactionCurrency: string;
    public ProductCountry: string;
    public TransactionPin: string
    public deviceId: string;
    public LoginType: LoginPasswordType;
    public TokenReference: string;
}

export class Biller{
    public BillerId: number;
    public BillerLocationId: number;
    public BillerName: string;
    public CategoryType: any;
    public Country: string;
    public Currency: string;
    public LogoUrl: string;
    public ProcessorExtNo: string;
    public SubCategoryType: any;
    public MinAmount?: number | null;
    public MaxAmount?: number | null;
}

export class WalletBillPayRequestBody {
    public CustomerId: string;
    public AccountNumber: string;
    public BillerlocationId: number;
    public InvoiceNumber: string;
    public InvoiceDate: string;
    public ProductCountry: string;
    public TransactionAmount: number;
    public TransactionCurrency: string;
    public TransactionPin: string;
    public BillerName: string;
    public deviceId: string;
    public LoginType: LoginPasswordType;
    public TokenReference: string;
  }


// WEBPACK FOOTER //
// ./src/model/models/wallet/wallet-services.ts